
export { LESSON_PRIORITY } from "/vercel/path0/packages/shared-values/src/constants/academy/lesson/lesson.ts"